import { defineMessages } from 'react-intl';

export default defineMessages({
  nextButton: {
    id: 'view.newForm.component.nextButton',
    defaultMessage: 'Next',
  },
  previousButton: {
    id: 'view.newForm.component.previousButton',
    defaultMessage: 'Previous',
  },
  choiceInvoiceButtonHasInvoice: {
    id: 'view.newForm.step.choiceInvoiceTitle.button.hasInvoice',
    defaultMessage: 'has invoice {sellerName}',
  },
  choiceInvoiceButtonHasPartner: {
    id: 'view.newForm.step.choiceInvoiceTitle.button.hasPartner',
    defaultMessage: 'has partner {sellerName}',
  },
  choiceInvoiceButtonHasNotInvoice: {
    id: 'view.newForm.step.choiceInvoiceTitle.button.hasNotInvoice',
    defaultMessage: 'has not invoice',
  },
  choiceInvoiceSubtitle: {
    id: 'view.newForm.step.choiceInvoiceSubtitle',
    defaultMessage:
      'Get your invoice by logging into your customer account. {link}.',
  },
  choiceInvoiceSubtitleSuffix: {
    id: 'view.newForm.step.choiceInvoiceSubtitleSuffix',
    defaultMessage: 'Log in to customer account',
  },
  choiceProductUniversModelTitle: {
    id: 'view.newForm.step.choiceProductUniversModelTitle',
    defaultMessage: 'What type of product do you need help with?',
  },
  choiceProductGenericModelTitle: {
    id: 'view.newForm.step.choiceProductGenericModelTitle',
    defaultMessage: 'We need to identify your product',
  },
  choiceProductGenericModelSubtitleSuffix: {
    id: 'view.newForm.step.choiceProductGenericModelSubtitleSuffix',
    defaultMessage: 'Enter your invoice number',
  },
  choiceProductGenericModelFindMyProductCategory: {
    id: 'view.newForm.step.choiceProductGenericModel.placeHolder.findMyProductCategory',
    defaultMessage: 'find my product category',
  },
  choiceProductGenericModelFindMyProductBrand: {
    id: 'view.newForm.step.choiceProductGenericModel.placeHolder.findMyProductBrand',
    defaultMessage: 'find my product brand',
  },
  choicePartnerPurchaseStore: {
    id: 'view.newForm.step.choicePartnerPurchaseStore.placeHolder.findMyProductStore',
    defaultMessage: 'find my product store',
  },
  findMyBrandName: {
    id: 'components.myaccount.claims.placeHolder.findMyBrandName',
    defaultMessage: 'find my product brand',
  },
  customerInformationNameTitle: {
    id: 'view.newForm.step.customerInformationNameTitle',
    defaultMessage: 'Personal information',
  },
  customerInformationNameSubtitle: {
    id: 'view.newForm.step.customerInformationNameSubtitle',
    defaultMessage:
      'You will then be able to track the progress of your request.',
  },
  customerInformationAddressTitle: {
    id: 'view.newForm.step.customerInformationAddressTitle',
    defaultMessage: 'Enter your postal address',
  },
  customerInformationAddressSubtitle: {
    id: 'view.newForm.step.customerInformationAddressSubtitle',
    defaultMessage:
      'You will then be able to track the progress of your request.',
  },
  customerInvoiceInformationTitle: {
    id: 'view.newForm.step.customerInvoiceInformationTitle',
    defaultMessage: 'Information about your invoice',
  },
  customerInvoiceInformationSubtitle: {
    id: 'view.newForm.step.customerInvoiceInformationSubtitle',
    defaultMessage: "Don't have an invoice? Make a request without an invoice",
  },
});
